import React from "react";
import {
    faBuilding, faCheckCircle, faClock,
   faLayerGroup, faRulerCombined, faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";
import ProductTypes from "../../components/ProductTypes";

const MetalFabricationAssembly = () => {
    const products = [

        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165602/FlangeHeadRivet_ii2nh2.webp", name: "Flange Head Rivet" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165641/PopRivets_nloyn7.webp", name: "Pop Rivets" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165595/CageNuts_xyfsdl.webp", name: "Cage Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165655/WeldBolt_ece24l.webp", name: "Weld Bolt" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759241582/SquareWeldNuts_txujdh.webp", name: "Square Weld Nuts" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070858/RivetNutFullHex_igmxuy.webp", name: "Full Hex Rivet Nuts" },
    ];

    const bannerImage = "https://res.cloudinary.com/dbirahuue/image/upload/v1759157232/MetalFabricationAssembly_fja6bf.webp";
    const heading = "Metal Fabrication & Assembly";
    const description =
        "Our Metal Fabrication & Assembly fasteners are precision-engineered to provide strength, reliability, and efficiency across structural and industrial applications. Suitable for sheet metal, heavy-duty frames, and precision assemblies, they deliver seamless fabrication, minimize downtime, and ensure long-lasting performance.";

    const benefits = [
        { icon: faBuilding, text: "Optimized for sheet metal and heavy-duty assemblies" },
        { icon: faRulerCombined, text: "Ensures accurate fabrication and assembly" },
        { icon: faShieldHalved, text: "Built for long-term industrial performance" },
        { icon: faClock, text: "Simplifies fabrication and shortens assembly time" },
        { icon: faLayerGroup, text: "Compatible with multiple fabrication processes" },
        { icon: faCheckCircle, text: "Ensures stability and safety even under heavy stress" },
    ];

    return (
        <ProductTypes
            products={products}
            image={bannerImage}
            heading={heading}
            description={description}
            benefits={benefits}
        />
    );
};

export default MetalFabricationAssembly;
